// import { FiberManualRecord as BulletPointIcon } from '@mui/icons-material';
// import {
//   Autocomplete,
//   Box,
//   Button,
//   Collapse,
//   Divider,
//   Grid,
//   IconButton,
//   List,
//   ListItem,
//   ListItemIcon,
//   Paper,
//   TextField,
//   Typography,
//   useTheme
// } from '@mui/material';
// import React from 'react';
// import { Controller, FieldErrors } from 'react-hook-form';
// import { FaChevronDown, FaChevronUp, FaHandsHelping, FaPlus, FaTrash } from 'react-icons/fa';
// import { useDispatch } from 'react-redux';
// import { fetchSupportItems } from 'slices/NdisSlices/carePlanInfo/CarePlanInfoSlice';
// import { SectionProps } from '../../../../types/ndisSection/carePlanInfoTypes';
// import { CareTextField, SectionHeader } from '../Components';
// import { AppDispatch } from 'app/store';

// interface SupportItem {
//   supportItemNumber: string;
//   supportItemName: string;
//   registrationGroupName: string;
//   supportCategoryName: string;
//   supportCategoryNamePACE: string;
//   state: string;
//   value: number;
// }

// const getNestedValue = (obj: any, path: string): string => {
//   if (!obj) return 'Not provided';
//   const keys = path.split('.');
//   let current = obj;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return 'Not provided';
//     }
//   }
//   return current || 'Not provided';
// };

// const getNestedError = (errors: FieldErrors<any>, path: string): any => {
//   const keys = path.split('.');
//   let current: any = errors;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return undefined;
//     }
//   }
//   return current;
// };

// type SupportPlanField = {
//   label: string;
//   name: (index: number) => string;
//   width?: 'full' | 'half';
// };

// const DirectedSupportPlanSection: React.FC<SectionProps> = ({
//   editMode,
//   isMobile,
//   handleEditToggle,
//   handleSubmit,
//   handleCancel,
//   control,
//   errors,
//   getValues,
//   carePlan,
//   directedSupportPlans,
//   setDirectedSupportPlans
// }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch<AppDispatch>();
//   const spacing = isMobile ? 1 : 2;
//   const [expandedPlans, setExpandedPlans] = React.useState<number[]>([]);

//   // Per-plan states
//   const [supportItemsByIndex, setSupportItemsByIndex] = React.useState<{
//     [key: number]: SupportItem[];
//   }>({});
//   const [searchQueriesByIndex, setSearchQueriesByIndex] = React.useState<{
//     [key: number]: string;
//   }>({});
//   const [loadingByIndex, setLoadingByIndex] = React.useState<{
//     [key: number]: boolean;
//   }>({});

//   const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//     projectId?: string;
//   };
//   const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//     selectedServiceTitle?: string;
//   };
//   const group_id = project.projectId || '';
//   const service_id = service.selectedServiceTitle || '';

//   // Initialize states for new plans only, preserving existing state
//   React.useEffect(() => {
//     setSupportItemsByIndex((prev) => {
//       const updatedSupportItems = { ...prev };
//       directedSupportPlans.forEach((plan, index) => {
//         // Only initialize if the index doesn't exist in the state
//         if (!updatedSupportItems[index]) {
//           updatedSupportItems[index] = [];
//           // If plan has a CareNeed value, add it to supportItems to ensure it's selectable
//           if (plan.CareNeed && editMode) {
//             const [number, name] = plan.CareNeed.split('|');
//             if (number && name) {
//               updatedSupportItems[index] = [
//                 {
//                   supportItemNumber: number,
//                   supportItemName: name,
//                   registrationGroupName: '',
//                   supportCategoryName: '',
//                   supportCategoryNamePACE: '',
//                   state: '',
//                   value: 0
//                 }
//               ];
//             }
//           }
//         }
//       });
//       return updatedSupportItems;
//     });

//     setSearchQueriesByIndex((prev) => {
//       const updatedSearchQueries = { ...prev };
//       directedSupportPlans.forEach((_, index) => {
//         if (!(index in updatedSearchQueries)) {
//           updatedSearchQueries[index] = '';
//         }
//       });
//       return updatedSearchQueries;
//     });

//     setLoadingByIndex((prev) => {
//       const updatedLoading = { ...prev };
//       directedSupportPlans.forEach((_, index) => {
//         if (!(index in updatedLoading)) {
//           updatedLoading[index] = false;
//         }
//       });
//       return updatedLoading;
//     });
//   }, [directedSupportPlans, editMode]);

//   // Fetch items per plan when search queries change
//   React.useEffect(() => {
//     const fetchItems = async (index: number, query: string) => {
//       if (editMode && query && query.length > 2) {
//         try {
//           setLoadingByIndex((prev) => ({ ...prev, [index]: true }));
//           const resultAction = await dispatch(
//             fetchSupportItems({ group_id, service_name_id: service_id, query })
//           );
//           if (fetchSupportItems.fulfilled.match(resultAction)) {
//             const transformedItems = resultAction.payload.map((item: any) => ({
//               supportItemNumber: item['Support Item Number'] || item.supportItemNumber,
//               supportItemName: item['Support Item Name'] || item.supportItemName,
//               registrationGroupName: item['Registration Group Name'] || item.registrationGroupName,
//               supportCategoryName: item['Support Category Name'] || item.supportCategoryName,
//               supportCategoryNamePACE:
//                 item['Support Category Name (PACE)'] || item.supportCategoryNamePACE,
//               state: item.State || item.state,
//               value: item.Value || item.value
//             }));

//             // Preserve the selected value if it exists in the form
//             const currentValue = getValues(`DirectedSupportPlan.${index}.CareNeed`);
//             if (currentValue) {
//               const [number, name] = currentValue.split('|');
//               const selectedItem = transformedItems.find(
//                 (item) => item.supportItemNumber === number && item.supportItemName === name
//               );
//               if (!selectedItem && number && name) {
//                 transformedItems.unshift({
//                   supportItemNumber: number,
//                   supportItemName: name,
//                   registrationGroupName: '',
//                   supportCategoryName: '',
//                   supportCategoryNamePACE: '',
//                   state: '',
//                   value: 0
//                 });
//               }
//             }

//             setSupportItemsByIndex((prev) => ({ ...prev, [index]: transformedItems }));
//           }
//         } catch (error) {
//           console.error(`Failed to fetch support items for plan ${index}:`, error);
//           setSupportItemsByIndex((prev) => ({ ...prev, [index]: [] }));
//         } finally {
//           setLoadingByIndex((prev) => ({ ...prev, [index]: false }));
//         }
//       }
//     };

//     Object.entries(searchQueriesByIndex).forEach(([index, query]) => {
//       const idx = Number(index);
//       if (query !== undefined) {
//         fetchItems(idx, query);
//       }
//     });
//   }, [searchQueriesByIndex, dispatch, group_id, service_id, editMode, getValues]);

//   const togglePlan = (index: number) => {
//     setExpandedPlans((prev) =>
//       prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
//     );
//   };

//   // Wrap handleSubmit to debug form values
//   const wrappedHandleSubmit = (data: any) => {
//     console.log('Form submission data:', JSON.stringify(data, null, 2));
//     handleSubmit(data);
//   };

//   const fields: SupportPlanField[] = [
//     {
//       label: 'Support Item',
//       name: (index) => `DirectedSupportPlan.${index}.CareNeed`,
//       width: 'half'
//     },
//     {
//       label: 'Frequency',
//       name: (index) => `DirectedSupportPlan.${index}.FrequencyOfServices`,
//       width: 'half'
//     },
//     {
//       label: 'Action Strategies',
//       name: (index) => `DirectedSupportPlan.${index}.ActionStrategies`,
//       width: 'full'
//     },
//     {
//       label: 'Visit Duration',
//       name: (index) => `DirectedSupportPlan.${index}.VisitTimeDuration`,
//       width: 'half'
//     },
//     {
//       label: 'Responsible Person',
//       name: (index) => `DirectedSupportPlan.${index}.ResponsiblePerson`,
//       width: 'half'
//     },
//     {
//       label: 'By When',
//       name: (index) => `DirectedSupportPlan.${index}.ByWhen`,
//       width: 'half'
//     }
//   ];

//   const addNewPlan = () => {
//     const newIndex = directedSupportPlans.length;
//     setDirectedSupportPlans([
//       ...directedSupportPlans,
//       {
//         CareNeed: '',
//         FrequencyOfServices: '',
//         ActionStrategies: '',
//         VisitTimeDuration: '',
//         ResponsiblePerson: '',
//         ByWhen: ''
//       }
//     ]);
//     setExpandedPlans([...expandedPlans, newIndex]);
//   };

//   const removePlan = (index: number) => {
//     const newPlans = [...directedSupportPlans];
//     newPlans.splice(index, 1);
//     setDirectedSupportPlans(newPlans);
//     setExpandedPlans(expandedPlans.filter((i) => i !== index));

//     setSupportItemsByIndex((prev) => {
//       const newSupportItems = { ...prev };
//       delete newSupportItems[index];
//       return newSupportItems;
//     });

//     setSearchQueriesByIndex((prev) => {
//       const newQueries = { ...prev };
//       delete newQueries[index];
//       return newQueries;
//     });

//     setLoadingByIndex((prev) => {
//       const newLoading = { ...prev };
//       delete newLoading[index];
//       return newLoading;
//     });
//   };

//   return (
//     <Paper
//       elevation={2}
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: 2,
//         overflow: 'hidden',
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto'
//       }}
//     >
//       <SectionHeader
//         icon={<FaHandsHelping size={isMobile ? 16 : 20} />}
//         title="Directed Support Plan"
//         color={theme.palette.secondary.dark}
//         editMode={editMode}
//         handleEditToggle={handleEditToggle}
//         handleSubmit={wrappedHandleSubmit}
//         handleCancel={handleCancel}
//         getValues={getValues}
//       />

//       <Box sx={{ p: isMobile ? 1 : 2 }}>
//         {editMode ? (
//           <>
//             {directedSupportPlans.map((plan, index) => (
//               <Paper
//                 key={index}
//                 elevation={1}
//                 sx={{
//                   mb: spacing,
//                   p: isMobile ? 1 : 2,
//                   backgroundColor: theme.palette.background.default,
//                   borderRadius: 1
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     mb: 1
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       color: theme.palette.secondary.main,
//                       fontWeight: 600
//                     }}
//                   >
//                     Support Plan #{index + 1}
//                   </Typography>
//                   <Box>
//                     {directedSupportPlans.length > 1 && (
//                       <IconButton
//                         size="small"
//                         color="error"
//                         onClick={() => removePlan(index)}
//                         sx={{ mr: 1 }}
//                       >
//                         <FaTrash size={14} />
//                       </IconButton>
//                     )}
//                     <IconButton size="small" onClick={() => togglePlan(index)}>
//                       {expandedPlans.includes(index) ? <FaChevronUp /> : <FaChevronDown />}
//                     </IconButton>
//                   </Box>
//                 </Box>

//                 <Collapse in={expandedPlans.includes(index)}>
//                   <Grid container spacing={spacing}>
//                     {fields.map((field) => (
//                       <Grid
//                         item
//                         xs={12}
//                         sm={field.width === 'full' ? 12 : 6}
//                         key={field.name(index)}
//                       >
//                         {field.label === 'Support Item' ? (
//                           <Controller
//                             name={field.name(index) as any}
//                             control={control}
//                             render={({ field: controllerField }) => {
//                               const currentValue = controllerField.value || '';
//                               const [number, name] = currentValue.split('|');

//                               // Find the selected item or create a temporary one
//                               let selectedValue: SupportItem | null = null;
//                               if (number && name) {
//                                 selectedValue = supportItemsByIndex[index]?.find(
//                                   (item) =>
//                                     item.supportItemNumber === number &&
//                                     item.supportItemName === name
//                                 ) || {
//                                   supportItemNumber: number,
//                                   supportItemName: name,
//                                   registrationGroupName: '',
//                                   supportCategoryName: '',
//                                   supportCategoryNamePACE: '',
//                                   state: '',
//                                   value: 0
//                                 };
//                               }

//                               return (
//                                 <Autocomplete
//                                   options={supportItemsByIndex[index] || []}
//                                   value={selectedValue}
//                                   getOptionLabel={(option: SupportItem) =>
//                                     `${option.supportItemName} | ${option.supportItemNumber}`
//                                   }
//                                   isOptionEqualToValue={(option: SupportItem, value: SupportItem) =>
//                                     option.supportItemNumber === value.supportItemNumber &&
//                                     option.supportItemName === value.supportItemName
//                                   }
//                                   renderOption={(props, option: SupportItem) => (
//                                     <li {...props}>
//                                       <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="body2">
//                                           {option.supportItemName}
//                                         </Typography>
//                                         <Typography
//                                           variant="caption"
//                                           sx={{ color: theme.palette.text.secondary }}
//                                         >
//                                           {option.supportItemNumber}
//                                         </Typography>
//                                       </Box>
//                                     </li>
//                                   )}
//                                   onChange={(_, newValue: SupportItem | null) => {
//                                     controllerField.onChange(
//                                       newValue
//                                         ? `${newValue.supportItemNumber}|${newValue.supportItemName}`
//                                         : ''
//                                     );
//                                   }}
//                                   onInputChange={(_, newInputValue: string) => {
//                                     setSearchQueriesByIndex((prev) => ({
//                                       ...prev,
//                                       [index]: newInputValue
//                                     }));
//                                   }}
//                                   loading={loadingByIndex[index]}
//                                   loadingText="Loading..."
//                                   noOptionsText={
//                                     searchQueriesByIndex[index]?.length > 2
//                                       ? 'No support items found'
//                                       : 'Type at least 3 characters to search'
//                                   }
//                                   renderInput={(params) => (
//                                     <TextField
//                                       {...params}
//                                       label="Support Item"
//                                       size={isMobile ? 'small' : 'medium'}
//                                       helperText={
//                                         getNestedError(errors, field.name(index))?.message
//                                       }
//                                     />
//                                   )}
//                                 />
//                               );
//                             }}
//                           />
//                         ) : (
//                           <CareTextField
//                             label={field.label}
//                             name={field.name(index) as any}
//                             control={control}
//                             errors={errors}
//                             getValues={getValues}
//                             size={isMobile ? 'small' : 'medium'}
//                             multiline={field.width === 'full'}
//                             minRows={field.width === 'full' ? 3 : 1}
//                           />
//                         )}
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Collapse>
//               </Paper>
//             ))}

//             <Button
//               variant="outlined"
//               color="primary"
//               startIcon={<FaPlus size={14} />}
//               onClick={addNewPlan}
//               fullWidth
//               sx={{
//                 mt: 1,
//                 py: 1.5
//               }}
//             >
//               Add Support Plan
//             </Button>
//           </>
//         ) : (
//           <>
//             {directedSupportPlans?.length > 0 ? (
//               directedSupportPlans.map((plan, index) => (
//                 <Paper
//                   key={index}
//                   elevation={1}
//                   sx={{
//                     mb: spacing,
//                     overflow: 'hidden',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       boxShadow: theme.shadows[2]
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'center',
//                       p: isMobile ? 1 : 1.5,
//                       backgroundColor: theme.palette.secondary.light,
//                       cursor: 'pointer'
//                     }}
//                     onClick={() => togglePlan(index)}
//                   >
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         fontWeight: 600,
//                         color: theme.palette.secondary.dark
//                       }}
//                     >
//                       Support Plan #{index + 1}
//                     </Typography>
//                     <IconButton size="small" sx={{ color: theme.palette.secondary.contrastText }}>
//                       {expandedPlans.includes(index) ? <FaChevronUp /> : <FaChevronDown />}
//                     </IconButton>
//                   </Box>

//                   <Collapse in={expandedPlans.includes(index)}>
//                     <Box sx={{ p: isMobile ? 1 : 2 }}>
//                       <List dense disablePadding>
//                         {fields.map((field) => {
//                           const fieldName = field.name(index).split('.').pop() as keyof typeof plan;
//                           const value = plan[fieldName] || 'Not provided';
//                           const displayValue = value;

//                           return (
//                             <React.Fragment key={field.name(index)}>
//                               <ListItem
//                                 sx={{
//                                   py: 1,
//                                   px: 0,
//                                   alignItems: 'flex-start'
//                                 }}
//                               >
//                                 <ListItemIcon sx={{ minWidth: 24, mt: 0.5 }}>
//                                   <BulletPointIcon
//                                     sx={{
//                                       fontSize: '0.8rem',
//                                       color: theme.palette.text.secondary
//                                     }}
//                                   />
//                                 </ListItemIcon>
//                                 <Box sx={{ flex: 1 }}>
//                                   <Typography
//                                     variant="caption"
//                                     sx={{
//                                       fontWeight: 500,
//                                       color: theme.palette.text.secondary,
//                                       display: 'block',
//                                       lineHeight: 1.3
//                                     }}
//                                   >
//                                     {field.label}
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{
//                                       whiteSpace: 'pre-wrap',
//                                       wordBreak: 'break-word',
//                                       mt: 0.5
//                                     }}
//                                   >
//                                     {displayValue}
//                                   </Typography>
//                                 </Box>
//                               </ListItem>
//                               {field.width === 'full' && <Divider sx={{ my: 1 }} />}
//                             </React.Fragment>
//                           );
//                         })}
//                       </List>
//                     </Box>
//                   </Collapse>
//                 </Paper>
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontStyle: 'italic',
//                   textAlign: 'center',
//                   p: 2,
//                   color: theme.palette.text.secondary
//                 }}
//               >
//                 No directed support plans available
//               </Typography>
//             )}
//           </>
//         )}
//       </Box>
//     </Paper>
//   );
// };

// export default DirectedSupportPlanSection;



import { FiberManualRecord as BulletPointIcon } from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Paper,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import React from 'react';
import { Controller, FieldErrors, useFormContext } from 'react-hook-form';
import { FaChevronDown, FaChevronUp, FaHandsHelping, FaPlus, FaTrash } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { fetchSupportItems } from 'slices/NdisSlices/carePlanInfo/CarePlanInfoSlice';
import { SectionProps } from '../../../../types/ndisSection/carePlanInfoTypes';
import { CareTextField, SectionHeader } from '../Components';
import { AppDispatch } from 'app/store';

interface SupportItem {
  supportItemNumber: string;
  supportItemName: string;
  registrationGroupName: string;
  supportCategoryName: string;
  supportCategoryNamePACE: string;
  state: string;
  value: number;
}

const getNestedValue = (obj: any, path: string): string => {
  if (!obj) return 'Not provided';
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return 'Not provided';
    }
  }
  return current || 'Not provided';
};

const getNestedError = (errors: FieldErrors<any>, path: string): any => {
  const keys = path.split('.');
  let current: any = errors;
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return undefined;
    }
  }
  return current;
};

type SupportPlanField = {
  label: string;
  name: (index: number) => string;
  width?: 'full' | 'half';
};

const DirectedSupportPlanSection: React.FC<SectionProps> = ({
  editMode,
  isMobile,
  handleEditToggle,
  handleSubmit,
  handleCancel,
  control,
  errors,
  getValues,
  carePlan,
  directedSupportPlans,
  setDirectedSupportPlans
}) => {
  const theme = useTheme();
  const dispatch = useDispatch<AppDispatch>();
  const { setValue } = useFormContext(); // Use react-hook-form context to update form state
  const spacing = isMobile ? 1 : 2;
  const [expandedPlans, setExpandedPlans] = React.useState<number[]>([]);

  // Per-plan states
  const [supportItemsByIndex, setSupportItemsByIndex] = React.useState<{
    [key: number]: SupportItem[];
  }>({});
  const [searchQueriesByIndex, setSearchQueriesByIndex] = React.useState<{
    [key: number]: string;
  }>({});
  const [loadingByIndex, setLoadingByIndex] = React.useState<{
    [key: number]: boolean;
  }>({});

  const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
    projectId?: string;
  };
  const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
    selectedServiceTitle?: string;
  };
  const group_id = project.projectId || '';
  const service_id = service.selectedServiceTitle || '';

  // Initialize states for new plans only, preserving existing state
  React.useEffect(() => {
    setSupportItemsByIndex((prev) => {
      const updatedSupportItems = { ...prev };
      directedSupportPlans.forEach((plan, index) => {
        if (!updatedSupportItems[index]) {
          updatedSupportItems[index] = [];
          if (plan.CareNeed && editMode) {
            const [number, name] = plan.CareNeed.split('|');
            if (number && name) {
              updatedSupportItems[index] = [
                {
                  supportItemNumber: number,
                  supportItemName: name,
                  registrationGroupName: '',
                  supportCategoryName: '',
                  supportCategoryNamePACE: '',
                  state: '',
                  value: 0
                }
              ];
            }
          }
        }
      });
      Object.keys(updatedSupportItems).forEach((key) => {
        const idx = Number(key);
        if (idx >= directedSupportPlans.length) {
          delete updatedSupportItems[idx];
        }
      });
      return updatedSupportItems;
    });

    setSearchQueriesByIndex((prev) => {
      const updatedSearchQueries = { ...prev };
      directedSupportPlans.forEach((_, index) => {
        if (!(index in updatedSearchQueries)) {
          updatedSearchQueries[index] = '';
        }
      });
      Object.keys(updatedSearchQueries).forEach((key) => {
        const idx = Number(key);
        if (idx >= directedSupportPlans.length) {
          delete updatedSearchQueries[idx];
        }
      });
      return updatedSearchQueries;
    });

    setLoadingByIndex((prev) => {
      const updatedLoading = { ...prev };
      directedSupportPlans.forEach((_, index) => {
        if (!(index in updatedLoading)) {
          updatedLoading[index] = false;
        }
      });
      Object.keys(updatedLoading).forEach((key) => {
        const idx = Number(key);
        if (idx >= directedSupportPlans.length) {
          delete updatedLoading[idx];
        }
      });
      return updatedLoading;
    });
  }, [directedSupportPlans, editMode]);

  // Fetch items per plan when search queries change
  React.useEffect(() => {
    const fetchItems = async (index: number, query: string) => {
      if (editMode && query && query.length > 2) {
        try {
          setLoadingByIndex((prev) => ({ ...prev, [index]: true }));
          const resultAction = await dispatch(
            fetchSupportItems({ group_id, service_name_id: service_id, query })
          );
          if (fetchSupportItems.fulfilled.match(resultAction)) {
            const transformedItems = resultAction.payload.map((item: any) => ({
              supportItemNumber: item['Support Item Number'] || item.supportItemNumber,
              supportItemName: item['Support Item Name'] || item.supportItemName,
              registrationGroupName: item['Registration Group Name'] || item.registrationGroupName,
              supportCategoryName: item['Support Category Name'] || item.supportCategoryName,
              supportCategoryNamePACE:
                item['Support Category Name (PACE)'] || item.supportCategoryNamePACE,
              state: item.State || item.state,
              value: item.Value || item.value
            }));

            const currentValue = getValues(`DirectedSupportPlan.${index}.CareNeed`);
            if (currentValue) {
              const [number, name] = currentValue.split('|');
              const selectedItem = transformedItems.find(
                (item) => item.supportItemNumber === number && item.supportItemName === name
              );
              if (!selectedItem && number && name) {
                transformedItems.unshift({
                  supportItemNumber: number,
                  supportItemName: name,
                  registrationGroupName: '',
                  supportCategoryName: '',
                  supportCategoryNamePACE: '',
                  state: '',
                  value: 0
                });
              }
            }

            setSupportItemsByIndex((prev) => ({ ...prev, [index]: transformedItems }));
          }
        } catch (error) {
          console.error(`Failed to fetch support items for plan ${index}:`, error);
          setSupportItemsByIndex((prev) => ({ ...prev, [index]: [] }));
        } finally {
          setLoadingByIndex((prev) => ({ ...prev, [index]: false }));
        }
      }
    };

    Object.entries(searchQueriesByIndex).forEach(([index, query]) => {
      const idx = Number(index);
      if (query !== undefined) {
        fetchItems(idx, query);
      }
    });
  }, [searchQueriesByIndex, dispatch, group_id, service_id, editMode, getValues]);

  const togglePlan = (index: number) => {
    setExpandedPlans((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const wrappedHandleSubmit = (data: any) => {
    console.log('Form submission data:', JSON.stringify(data, null, 2));
    handleSubmit(data);
  };

  const fields: SupportPlanField[] = [
    {
      label: 'Support Item',
      name: (index) => `DirectedSupportPlan.${index}.CareNeed`,
      width: 'half'
    },
    {
      label: 'Frequency',
      name: (index) => `DirectedSupportPlan.${index}.FrequencyOfServices`,
      width: 'half'
    },
    {
      label: 'Action Strategies',
      name: (index) => `DirectedSupportPlan.${index}.ActionStrategies`,
      width: 'full'
    },
    {
      label: 'Visit Duration',
      name: (index) => `DirectedSupportPlan.${index}.VisitTimeDuration`,
      width: 'half'
    },
    {
      label: 'Responsible Person',
      name: (index) => `DirectedSupportPlan.${index}.ResponsiblePerson`,
      width: 'half'
    },
    {
      label: 'By When',
      name: (index) => `DirectedSupportPlan.${index}.ByWhen`,
      width: 'half'
    }
  ];

  const addNewPlan = () => {
    const newIndex = directedSupportPlans.length;
    // Get current form values to preserve existing data
    const currentFormValues = getValues('DirectedSupportPlan') || directedSupportPlans;
    const newPlans = [
      ...currentFormValues,
      {
        CareNeed: '',
        FrequencyOfServices: '',
        ActionStrategies: '',
        VisitTimeDuration: '',
        ResponsiblePerson: '',
        ByWhen: ''
      }
    ];
    // Update both component state and form state
    setDirectedSupportPlans(newPlans);
    setValue('DirectedSupportPlan', newPlans, { shouldValidate: false });
    setExpandedPlans([...expandedPlans, newIndex]);
    console.log('After adding new plan:', { newPlans });
  };

  const removePlan = (index: number) => {
    const newPlans = [...directedSupportPlans];
    newPlans.splice(index, 1);
    setDirectedSupportPlans(newPlans);
    setValue('DirectedSupportPlan', newPlans, { shouldValidate: false });
    setExpandedPlans(expandedPlans.filter((i) => i !== index));

    setSupportItemsByIndex((prev) => {
      const newSupportItems = { ...prev };
      delete newSupportItems[index];
      return newSupportItems;
    });

    setSearchQueriesByIndex((prev) => {
      const newQueries = { ...prev };
      delete newQueries[index];
      return newQueries;
    });

    setLoadingByIndex((prev) => {
      const newLoading = { ...prev };
      delete newLoading[index];
      return newLoading;
    });
  };

  console.log('directedSupportPlans', directedSupportPlans);

  return (
    <Paper
      elevation={2}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100%',
        mx: 'auto'
      }}
    >
      <SectionHeader
        icon={<FaHandsHelping size={isMobile ? 16 : 20} />}
        title="Directed Support Plan"
        color={theme.palette.secondary.dark}
        editMode={editMode}
        handleEditToggle={handleEditToggle}
        handleSubmit={wrappedHandleSubmit}
        handleCancel={handleCancel}
        getValues={getValues}
      />

      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {editMode ? (
          <>
            {directedSupportPlans.map((plan, index) => (
              <Paper
                key={index}
                elevation={1}
                sx={{
                  mb: spacing,
                  p: isMobile ? 1 : 2,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: 600
                    }}
                  >
                    Support Plan #{index + 1}
                  </Typography>
                  <Box>
                    {directedSupportPlans.length > 1 && (
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => removePlan(index)}
                        sx={{ mr: 1 }}
                      >
                        <FaTrash size={14} />
                      </IconButton>
                    )}
                    <IconButton size="small" onClick={() => togglePlan(index)}>
                      {expandedPlans.includes(index) ? <FaChevronUp /> : <FaChevronDown />}
                    </IconButton>
                  </Box>
                </Box>

                <Collapse in={expandedPlans.includes(index)}>
                  <Grid container spacing={spacing}>
                    {fields.map((field) => (
                      <Grid
                        item
                        xs={12}
                        sm={field.width === 'full' ? 12 : 6}
                        key={field.name(index)}
                      >
                        {field.label === 'Support Item' ? (
                          <Controller
                            name={field.name(index) as any}
                            control={control}
                            render={({ field: controllerField }) => {
                              const currentValue = controllerField.value || '';
                              const [number, name] = currentValue.split('|');

                              let selectedValue: SupportItem | null = null;
                              if (number && name) {
                                selectedValue = supportItemsByIndex[index]?.find(
                                  (item) =>
                                    item.supportItemNumber === number &&
                                    item.supportItemName === name
                                ) || {
                                  supportItemNumber: number,
                                  supportItemName: name,
                                  registrationGroupName: '',
                                  supportCategoryName: '',
                                  supportCategoryNamePACE: '',
                                  state: '',
                                  value: 0
                                };
                              }

                              return (
                                <Autocomplete
                                  options={supportItemsByIndex[index] || []}
                                  value={selectedValue}
                                  getOptionLabel={(option: SupportItem) =>
                                    `${option.supportItemName} | ${option.supportItemNumber}`
                                  }
                                  isOptionEqualToValue={(option: SupportItem, value: SupportItem) =>
                                    option.supportItemNumber === value.supportItemNumber &&
                                    option.supportItemName === value.supportItemName
                                  }
                                  renderOption={(props, option: SupportItem) => (
                                    <li {...props}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="body2">
                                          {option.supportItemName}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: theme.palette.text.secondary }}
                                        >
                                          {option.supportItemNumber}
                                        </Typography>
                                      </Box>
                                    </li>
                                  )}
                                  onChange={(_, newValue: SupportItem | null) => {
                                    controllerField.onChange(
                                      newValue
                                        ? `${newValue.supportItemNumber}|${newValue.supportItemName}`
                                        : ''
                                    );
                                  }}
                                  onInputChange={(_, newInputValue: string) => {
                                    setSearchQueriesByIndex((prev) => ({
                                      ...prev,
                                      [index]: newInputValue
                                    }));
                                  }}
                                  loading={loadingByIndex[index]}
                                  loadingText="Loading..."
                                  noOptionsText={
                                    searchQueriesByIndex[index]?.length > 2
                                      ? 'No support items found'
                                      : 'Type at least 3 characters to search'
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Support Item"
                                      size={isMobile ? 'small' : 'medium'}
                                      helperText={
                                        getNestedError(errors, field.name(index))?.message
                                      }
                                    />
                                  )}
                                />
                              );
                            }}
                          />
                        ) : (
                          <CareTextField
                            label={field.label}
                            name={field.name(index) as any}
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            size={isMobile ? 'small' : 'medium'}
                            multiline={field.width === 'full'}
                            minRows={field.width === 'full' ? 3 : 1}
                          />
                        )}
                      </Grid>
                    ))}
                  </Grid>
                </Collapse>
              </Paper>
            ))}

            <Button
              variant="outlined"
              color="primary"
              startIcon={<FaPlus size={14} />}
              onClick={addNewPlan}
              fullWidth
              sx={{
                mt: 1,
                py: 1.5
              }}
            >
              Add Support Plan
            </Button>
          </>
        ) : (
          <>
            {directedSupportPlans?.length > 0 ? (
              directedSupportPlans.map((plan, index) => (
                <Paper
                  key={index}
                  elevation={1}
                  sx={{
                    mb: spacing,
                    overflow: 'hidden',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      boxShadow: theme.shadows[2]
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      p: isMobile ? 1 : 1.5,
                      backgroundColor: theme.palette.secondary.light,
                      cursor: 'pointer'
                    }}
                    onClick={() => togglePlan(index)}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        color: theme.palette.secondary.dark
                      }}
                    >
                      Support Plan #{index + 1}
                    </Typography>
                    <IconButton size="small" sx={{ color: theme.palette.secondary.contrastText }}>
                      {expandedPlans.includes(index) ? <FaChevronUp /> : <FaChevronDown />}
                    </IconButton>
                  </Box>

                  <Collapse in={expandedPlans.includes(index)}>
                    <Box sx={{ p: isMobile ? 1 : 2 }}>
                      <List dense disablePadding>
                        {fields.map((field) => {
                          const fieldName = field.name(index).split('.').pop() as keyof typeof plan;
                          const value = plan[fieldName] || 'Not provided';
                          const displayValue = value;

                          return (
                            <React.Fragment key={field.name(index)}>
                              <ListItem
                                sx={{
                                  py: 1,
                                  px: 0,
                                  alignItems: 'flex-start'
                                }}
                              >
                                <ListItemIcon sx={{ minWidth: 24, mt: 0.5 }}>
                                  <BulletPointIcon
                                    sx={{
                                      fontSize: '0.8rem',
                                      color: theme.palette.text.secondary
                                    }}
                                  />
                                </ListItemIcon>
                                <Box sx={{ flex: 1 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 500,
                                      color: theme.palette.text.secondary,
                                      display: 'block',
                                      lineHeight: 1.3
                                    }}
                                  >
                                    {field.label}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      whiteSpace: 'pre-wrap',
                                      wordBreak: 'break-word',
                                      mt: 0.5
                                    }}
                                  >
                                    {displayValue}
                                  </Typography>
                                </Box>
                              </ListItem>
                              {field.width === 'full' && <Divider sx={{ my: 1 }} />}
                            </React.Fragment>
                          );
                        })}
                      </List>
                    </Box>
                  </Collapse>
                </Paper>
              ))
            ) : (
              <Typography
                variant="body2"
                sx={{
                  fontStyle: 'italic',
                  textAlign: 'center',
                  p: 2,
                  color: theme.palette.text.secondary
                }}
              >
                No directed support plans available
              </Typography>
            )}
          </>
        )}
      </Box>
    </Paper>
  );
};

export default DirectedSupportPlanSection;